module.exports = __webpack_public_path__ + "static/media/university-adjustment-factors.82298263.jpg";